<template>
  <div>
    <rabbey-toolbox filterables @filter-search="handleSearch">
      <div class="mr-5">
        <el-button size="mini" type="primary" @click="handleClickImport"
          >Importar
        </el-button>
      </div>

      <div class="mr-5">
        <el-button
          size="mini"
          type="primary"
          @click="updateDbUbications"
          v-loading="loadingUbication"
          >Actualizacion ubicaciones
        </el-button>
      </div>
    </rabbey-toolbox>

    <el-row type="flex" justify="space-around" :gutter="10">
      <el-col v-for="(value, key) in listStats" :key="key">
        <CardStat
          :title="key"
          :val="value"
          icon="mdi mdi-checkbox-multiple-blank-outline"
        />
      </el-col>
    </el-row>

    <rabbey-table3
      :element-loading-text="loadingText"
      :loading="loading || loadingUbication"
      :columns="columns"
      :data="renderItems"
    ></rabbey-table3>

    <el-dialog
      title="Importar archivo"
      :visible.sync="dialogVisible"
      width="20%"
      @closed="fileList = []"
      center
    >
      <el-upload
        drag
        :action="uploadAction"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
        :on-error="handleError"
        :file-list="fileList"
        multiple
        :headers="{ Authorization: `Bearer ${token}` }"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">Solo archivos excel</div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="showDialogPreviewFile = true"
          size="mini"
          type="primary"
          >Ver archivo ejemplo</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="27%"
      title="Archivo ejemplo"
      :visible.sync="showDialogPreviewFile"
      center
    >
      <div class="wrapper">
        <div v-if="iframeLoaded" class="fallback">Cargando...</div>
        <iframe
          width="450"
          height="346"
          frameborder="0"
          scrolling="no"
          src="https://onedrive.live.com/embed?resid=3CFB02CC4D28DAEA%21175&authkey=%21AIDnnYJdqDwNim0&em=2&wdAllowInteractivity=False&wdDownloadButton=True&wdInConfigurator=True"
          @load="iframeLoad"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CardStat from "@/components/CardStat.vue";
import MaintenanceRenderCheck from "@/components/functionals/MaintenanceRenderCheck.vue";
import { formatDate } from "@/utils";
import { BASE_API_URL } from "@/const";

const baseUrl = process.env.VUE_APP_API_URL || BASE_API_URL;

export default {
  name: "ReportMaintenanceChip",
  components: {
    CardStat
  },
  created() {
    if (process.env.NODE_ENV !== "development") {
      this.uploadAction = this.urlPro;
    } else {
      this.uploadAction = this.urlDev;
    }

    this.fetchItems();
  },
  data() {
    return {
      search: "",
      iframeLoaded: true,
      fileList: [],
      dialogVisible: false,
      showDialogPreviewFile: false,
      loading: false,
      items: [],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true,
          fixed: true
        },
        {
          prop: "InternetProviderLabel",
          label: "Compañia",
          sortable: true,
          minWidth: 120
        },
        {
          prop: "Contract",
          label: "Contracto",
          minWidth: 130,
          sortable: true
        },
        {
          prop: "DateOfAdmission",
          label: "Fech. de Ingreso",
          width: 150,
          sortable: true,
          formatter: (row, column, cellValue) =>
            formatDate(cellValue, "DD/MM/YYYY")
        },
        {
          prop: "ActivatonDate",
          label: "Fech. de Activacion",
          width: 170,
          sortable: true,
          formatter: (row, column, cellValue) =>
            formatDate(cellValue, "DD/MM/YYYY")
        },
        {
          prop: "GetFormatContractedNumber",
          label: "Numero contratado",
          width: 180,
          sortable: true,
          columnKey: "ContractedNumber",
          sortBy: "ContractedNumber"
        },
        {
          prop: "InWarehouseGeneral",
          label: "Almacen General",
          width: 200,
          sortable: true,
          align: "center",
          formatter: MaintenanceRenderCheck
        },
        {
          prop: "InWarehouseSupport",
          label: "Almacen de  Soporte",
          width: 200,
          sortable: true,
          align: "center",
          formatter: MaintenanceRenderCheck
        },
        {
          prop: "InWarehouseClient",
          label: "Almacen del Cliete",
          width: 200,
          sortable: true,
          align: "center",
          formatter: MaintenanceRenderCheck
        },
        {
          prop: "InNavixy",
          label: "Navixy",
          width: 120,
          sortable: true,
          align: "center",
          formatter: MaintenanceRenderCheck
        }
      ],
      uploadAction: "/api/maintenanceReportChip",
      urlDev: "/api/maintenanceReportChip",
      urlPro: baseUrl + "/api/maintenanceReportChip",
      loadingUbication: false,
      loadingText: "Cargando..."
    };
  },
  computed: {
    token() {
      return localStorage.getItem("_token");
    },
    totalAltis() {
      // 0 = Altis
      return this.items.filter((f) => f.InternetProvider === 0).length;
    },
    totalClaro() {
      // 1 = Claro
      return this.items.filter((f) => f.InternetProvider === 1).length;
    },
    totalInWarehouseGeneral() {
      return this.items.filter((f) => f.InWarehouseGeneral === 1).length;
    },
    totalInWarehouseSupport() {
      return this.items.filter((f) => f.InWarehouseSupport === 1).length;
    },
    totalInWarehouseClient() {
      return this.items.filter((f) => f.InWarehouseClient === 1).length;
    },
    totalInNavixy() {
      return this.items.filter((f) => f.InNavixy === 1).length;
    },
    listStats() {
      return {
        Altis: this.totalAltis,
        Claro: this.totalClaro,
        "Almacén General": this.totalInWarehouseGeneral,
        "Almacén Soporte": this.totalInWarehouseSupport,
        "Almacén Cliente": this.totalInWarehouseClient,
        Navixy: this.totalInNavixy
      };
    },
    renderItems() {
      const search = this.search;
      let items = this.items;

      if (items.length <= 0) {
        return items;
      }

      this.toggleLoading();
      const keys = Object.keys(this.items[0]);

      if (search.length > 0) {
        items = items.filter((data) => {
          for (let i = 0; i < keys.length; i++) {
            let value = data[keys[i]];
            const valueType = typeof value;
            if (["number", "boolean"].includes(valueType)) {
              value = value.toString();
            }
            if (value && value.toLowerCase().includes(search.toLowerCase())) {
              return data;
            }
          }
        });
      }
      this.toggleLoading();
      return items;
    }
  },
  methods: {
    toggleLoading() {
      this.loadingText = "Cargando...";
      this.loading = !this.loading;
    },
    handleSearch(search) {
      this.search = search;
    },
    handleClickImport() {
      this.dialogVisible = true;
    },
    fetchItems() {
      this.loading = true;
      this.loadingText = "Cargando...";
      this.$http
        .get("/api/maintenanceReportChip")
        .then((res) => (this.items = res.data))
        .catch(console.error)
        .finally(() => (this.loading = false));
    },
    handleUploadSuccess() {
      this.fetchItems();
    },
    beforeUpload(file) {
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel"
        ].includes(file.type)
      ) {
        this.$message.warning(
          "El tipo de archivo es invalido, asegurese de que sea un excel"
        );
        return false;
      }

      return true;
    },
    handleError(/*err, file, fileList*/) {
      //console.log(err, file, fileList);
      this.$notify.error("Parece que tienes No. Tel. duplicados.");
    },
    iframeLoad() {
      this.iframeLoaded = false;
    },
    updateDbUbications() {
      this.loadingUbication = true;
      this.loadingText = "Localizando No de tel...";
      this.$http
        .post(
          "/api/maintenanceReportChip/UpdateDbUbication",
          {},
          { timeout: 3 * 60 * 1000 }
        )
        .then(({ data }) => {
          this.items = data;
          this.$notify.success("Localizando de CHIP terminada exitosamente.");
        })
        .catch(console.error)
        .finally(() => (this.loadingUbication = false));
    }
  }
};
</script>
